import I18n from '../../../config/i18n';

import './TranslationToggle.css';

interface TranslationToggleProps {
  showOriginalComment: boolean;
  toggleShowOriginal: () => void;
}

export default function TanslationToggle({
  showOriginalComment,
  toggleShowOriginal,
}: TranslationToggleProps): JSX.Element {
  function handleClick(e: React.MouseEvent<HTMLAnchorElement>): void {
    e.preventDefault();
    toggleShowOriginal();
  }

  return (
    <div className="translation-toggle">
      {showOriginalComment ? (
        <a onClick={(e): void => handleClick(e)}>
          {I18n.t('accommodation_reviews.show_translation')}
        </a>
      ) : (
        <span>
          {I18n.t('accommodation_reviews.review_translated')}
          {' – '}
          <a onClick={(e): void => handleClick(e)}>
            {I18n.t('accommodation_reviews.show_original')}
          </a>
        </span>
      )}
    </div>
  );
}
